import React from 'react';
import BookParcel from './create';

export default function editParcel() {
  return <BookParcel />;
}
